import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React from "react";

const TABS = ["prompts", "skills", "templates", "listings", "deployed", "test", "performance"] as const;

export default function AiAgentsManagement() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = TABS.find((tab) => location.pathname.includes(`/ai-agents/${tab}`)) ?? "templates";

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold mb-1">AI Agents</h2>
          <p className="text-muted-foreground text-sm">
            Create agent templates and publish them to the marketplace.
          </p>
        </div>
        <Button className="gap-1.5 shrink-0" onClick={() => navigate("/platform-admin/ai-agents/new")}>
          <Plus className="h-4 w-4" /> New agent
        </Button>
      </div>

      <Tabs value={activeTab} onValueChange={(nextTab) => navigate(`/platform-admin/ai-agents/${nextTab}`)}>
        <TabsList>
          <TabsTrigger value="prompts">Prompts</TabsTrigger>
          <TabsTrigger value="skills">Skills</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="listings">Marketplace Listings</TabsTrigger>
          <TabsTrigger value="deployed">Deployed Agents</TabsTrigger>
          <TabsTrigger value="test">Test Triggers</TabsTrigger>
          <TabsTrigger value="performance">Performance</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="pt-2">
        <Outlet />
      </div>
    </div>
  );
}
